import { Button, Stack, Text } from '@chakra-ui/react';
import { ReactNode, useEffect, useState } from 'react';

import { Visible, Popover } from 'components';

type FilterTileProps = {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  active?: boolean;
  onOpen: (name: string) => void;
  width?: number;
};
const FilterTile = ({ title, subtitle, children, active, onOpen, width }: FilterTileProps) => {
  const [activeFilter, setActiveFilter] = useState(active);

  useEffect(() => {
    setActiveFilter(active);
  }, [active]);

  const onClickButton = () => {
    onOpen(activeFilter ? '' : title.toLowerCase());
    setActiveFilter(true);
  };

  const popoverTrigger = () => (
    <Button
      boxShadow={activeFilter ? '0px 25px 50px -12px rgba(151, 151, 151, 0.25)' : ''}
      borderRadius={85}
      size='lg'
      paddingLeft='40px'
      paddingRight='40px'
      onClick={onClickButton}
      paddingTop='40px'
      paddingBottom='40px'
      background={activeFilter ? '#FEFEFE' : 'none'}
    >
      <Stack direction='column' spacing={1} alignItems='flex-start !important'>
        <Text
          color={activeFilter ? 'black' : 'white'}
          fontFamily='Montserrat'
          fontWeight={700}
          lineHeight='150%'
          fontSize={15}
        >
          {title}
        </Text>
        <Visible when={!!subtitle}>
          <Text fontWeight={400} color={activeFilter ? 'black' : 'white'} fontSize={14} fontFamily='Montserrat'>
            {subtitle}
          </Text>
        </Visible>
      </Stack>
    </Button>
  );
  return (
    <Popover width={width} onClose={() => setActiveFilter(false)} trigger={popoverTrigger()}>
      {children}
    </Popover>
  );
};

export { FilterTile };
